import { useState } from "react";
import { addonSelect, formatterDate } from "../../../utils";
import { colors } from "../../colors";
import { CalendarIcon } from "../../icons/calendar";
import { EditIcon } from "../../icons/edit";
import { TrashIcon } from "../../icons/trash";
import { AddOnPopup } from "../addOnPopup";
import { ButtonComponent } from "../button/newButton";

interface Props {
  title: string;
  onDelete: () => void;
  startDate: Date;
  endDate: Date | undefined;
  note?: string;
  id?: number;
  idx?: number;
  onEdit?: boolean;
  mode?: "create" | "edit";
  customerId?: string | number;
}

export function AddOnComponent(props: Props) {
  const { title, onDelete, startDate, endDate, note, id, onEdit, idx, mode, customerId } = props;
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <div className="flex flex-col w-full min-w-0 border rounded-2xl px-6 py-5 shadow-sm hover:shadow-md transition-shadow" style={{ borderColor: colors.brandPrimary[200], backgroundColor: colors.white }}>
      <div className="flex items-center justify-between border-b pb-3 mb-3" style={{ borderColor: colors.brandPrimary[200] }}>
        <span className="text-base font-['Manrope'] font-bold leading-[20px] text-left flex items-center gap-2" style={{ color: colors.brandPrimary[800] }}>
          {
            addonSelect.filter(({ value }) => value === title).map(el =>
              <span key={el.value} className="text-left font-bold" style={{ color: colors.brandSecondary[900] }}>{el.label}</span>
            )
          }
        </span>
        <div className="flex">
          <ButtonComponent
            size="sm"
            variant="link"
            color="gray"
            iconPosition="only"
            icon={<EditIcon size={14} color={colors.neutral[500]} />}
            onClick={() => setShowModal(true)}
          />
          <ButtonComponent
            size="sm"
            variant="link"
            color="red"
            iconPosition="only"
            icon={<TrashIcon size={14} color={colors.red[500]} />}
            onClick={onDelete}
          />
        </div>
      </div>

      <div className="flex flex-row gap-4 mb-3">
        <div className="flex items-center border rounded-xl bg-white px-3 py-2 min-h-[56px] flex-1" style={{ borderColor: colors.neutral[200] }}>
          <div className="flex items-center justify-center p-2 rounded-md" style={{ backgroundColor: colors.brandPrimary[100] }}>
            <CalendarIcon size={16} color={colors.brandPrimary[500]} />
          </div>
          <div className="flex flex-col text-left justify-center flex-1 ml-2">
            <span className="text-xs font-semibold uppercase tracking-wider" style={{ color: colors.brandPrimary[500] }}>Dal</span>
            <span className="text-sm font-['Manrope'] font-semibold leading-[18px]" style={{ color: colors.brandPrimary[800] }}>{formatterDate(startDate)}</span>
          </div>
        </div>
        <div className="flex items-center border rounded-xl bg-white px-3 py-2 min-h-[56px] flex-1" style={{ borderColor: colors.neutral[200] }}>
          <div className="flex items-center justify-center p-2 rounded-md" style={{ backgroundColor: colors.brandPrimary[100] }}>
            <CalendarIcon size={16} color={colors.brandPrimary[500]} />
          </div>
          <div className="flex flex-col text-left justify-center flex-1 ml-2">
            <span className="text-xs font-semibold uppercase tracking-wider" style={{ color: colors.brandPrimary[500] }}>Al</span>
            <span className="text-sm font-['Manrope'] font-semibold leading-[18px]" style={{ color: colors.brandPrimary[800] }}>{formatterDate(endDate)}</span>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between w-full min-w-0">
        <div className="rounded-xl px-4 py-3 border border-dashed flex-1 text-left relative overflow-hidden min-w-0" style={{ backgroundColor: colors.neutral[50], borderColor: colors.brandPrimary[200] }}>
          <span className="text-sm font-['Manrope'] font-normal leading-[20px] italic block break-words" style={{ wordBreak: 'break-word', color: colors.brandSecondary[600] }}>{note ? note : "Nessuna nota aggiuntiva..."}</span>
        </div>
      </div>

      {showModal && (
        <AddOnPopup
          idx={idx}
          visible={showModal}
          id={id}
          onEdit={onEdit}
          mode={mode}
          closeHandler={() => setShowModal(false)}
        />
      )}
    </div>
  );
}